const compactStrlen = str => {
  let strlen = 0;
  for (let i = 0; i < str.length; i++) {
    const char = str.charAt(i);
    if (/[u00-uFF]/g.test(char)) {
      strlen++;
    } else {
      strlen += 2;
    }
  }
  return strlen;
};

export default compactStrlen;
